export default {
  welcome: '素材をここに追加して、大作を始めましょう〜',
  tool: {
    zoomout: '縮小',
    zoomin: '拡大',
  },
  loading: '読み込み中...',
  loadfail: '読み込み失敗',
}
